import React, { useState, useMemo, useEffect } from "react";
import ReactDOM from "react-dom";
import api from "../../../apis/api";

const loginUser = JSON.parse(localStorage.getItem("user") || "{}");

const emptyRow = (id) => ({
  __localId: id,
  projectId: "",
  projectName: "",
  issueTitle: "",
  hoursSpent: "0.0",
  hoursBillable: "0.0",
  dutyTypeId: "",
  status: "",
  description: "",
  workDate: new Date().toISOString().split("T")[0],
  employeeTimeSheetId: null,
  employeeTimeSheetStatusId: null,
});

export default function AddEditTaskDetails({
  mode = "add",
  initialDate = new Date(),
  initialRows = [],
  dutytypeList = [],
  projectList = [],
  onClose = () => {},
  onSaved = () => {},
  savingLabel = "Save Timesheet",
  handleClsAddEditTaskForm,
    handleAddUpdateTask,
    selectedTask,
    taskProjectInfo,
    addOrEdit,
    getAllTaskOfEmployee,
    setIsOpenAddEditForm,
    unlockReqList,
    LeaveReq,
    handleCloseAddEditForm,
    datearraylast,
    datearray,
    datearraylastAll,
    updatestatus,
    isInitialRender,
    isOpenAddEditForm,
    LeaveReqList,
    datearraylastdisable,
    
    autoDutyType,
    recHolidayList,
    plannedLeaveList
}) {
  try { console.debug('[AED] AddEditTaskDetails render called, isOpenAddEditForm=', isOpenAddEditForm); } catch(e){}
  const getStartOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    d.setDate(diff);
    return new Date(d);
  };

  const [currentWeekStart, setCurrentWeekStart] = useState(() => getStartOfWeek(initialDate));
  const [selectedDate, setSelectedDate] = useState(() => new Date(initialDate));
  const [projects, setProjects] = useState([]);
  const [taskList, settaskList] = useState([]);
  const [checkValue,setcheckValue] =useState(0);
  const [rows, setRows] = useState(() =>
    initialRows.length > 0
      ? initialRows.map((r, i) => ({
          __localId: `r_${i}_${r.employeeTimeSheetId || Math.random()}`,
          projectId: r.projectID ?? r.projectId ?? "",
          projectName: r.projectName ?? "",
          issueTitle: r.issueTitle ?? "",
          hoursSpent: r.workingHours ?? r.hoursSpent ?? "0.0",
          hoursBillable: r.hoursBillable ?? "0.0",
          dutyTypeId: r.dutyTypeId ?? "",
          status: r.status ?? "",
          description: r.description ?? "",
          workDate: r.workDate ?? new Date().toISOString().split("T")[0],
          employeeTimeSheetId: r.employeeTimeSheetId ?? null,
          employeeTimeSheetStatusId: r.employeeTimeSheetStatusId ?? null,
        }))
      : [emptyRow("init_1")]
  );

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const weekDays = useMemo(() => {
    const d = new Date(currentWeekStart);
    return Array.from({ length: 7 }, (_, i) => {
      const dd = new Date(d);
      dd.setDate(currentWeekStart.getDate() + i);
      return dd;
    });
  }, [currentWeekStart]);

  const formatDateRange = () => {
    const start = weekDays[0];
    const end = weekDays[6];
    return `${start.toLocaleDateString(undefined, { month: "short", day: "numeric" })} - ${end.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}`;
  };

  const navigateWeek = (dir) => {
    const newStart = new Date(currentWeekStart);
    if (dir === "prev") newStart.setDate(newStart.getDate() - 7);
    if (dir === "next") newStart.setDate(newStart.getDate() + 7);
    setCurrentWeekStart(newStart);
  };
 const handlecloseform = () => {
  try { console.debug('[AED] handlecloseform invoked'); } catch (e) {}
  // Log for debugging: ensure the handler is invoked
  try {
    // eslint-disable-next-line no-console
    console.log("AddEditTaskDetails: handlecloseform invoked");
  } catch (e) {}

  // Call the parent's close/cleanup handlers similar to AddEditTask
  if (typeof handleClsAddEditTaskForm === "function") {
    try {
      // pass the current mode (add/edit) if available — parent may accept event or mode
      handleClsAddEditTaskForm(addOrEdit);
    } catch (err) {
      try {
        handleClsAddEditTaskForm();
      } catch (e) {
        // swallow
      }
    }
  }

  if (typeof handleCloseAddEditForm === "function") {
    try {
      handleCloseAddEditForm();
    } catch (err) {
      // swallow
    }
  }

  // Reset internal modal state to defaults (like the other form does)
  try {
    setRows([emptyRow(`r_${Date.now()}`)]);
  } catch (e) {}
  try {
    setSelectedDate(new Date(initialDate));
  } catch (e) {}
  try {
    setCurrentWeekStart(getStartOfWeek(initialDate));
  } catch (e) {}
  try {
    setMessage(null);
    setLoading(false);
  } catch (e) {}

  // As a safety fallback, ensure the parent boolean is updated
  if (typeof setIsOpenAddEditForm === "function") {
    try {
      try { console.debug('[AED] calling setIsOpenAddEditForm(false)'); } catch(e){}
      setIsOpenAddEditForm(false);
    } catch (err) {}
  }
};
   useEffect(() =>{
if(isOpenAddEditForm === true)
  {
    setcheckValue(0);
  }
  if (loginUser?.EmployeeId) {
    setProjects([]);
api.project()
      .getProjectsOfEmployee(loginUser.EmployeeId)
      .then((res) => {
        setProjects(res.data); // assuming res.data is the array of projects
      })
      .catch((err) => {
        console.error("Error fetching projects: ", err);
      });
  }

    },[isOpenAddEditForm])
  const navArrowStyle = { padding: 6, borderRadius: 6, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer" };
  const dayCardStyle = (isSel, isWeekend) => ({ padding: 16, borderRadius: 8, border: "1px solid #e5e7eb", background: isSel ? "#ecfdf5" : isWeekend ? "#fff1f2" : "#fff", cursor: "pointer" });
  const inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 6, border: "1px solid #e5e7eb" };

  const handleSelectDay = (day) => {
    setSelectedDate(day);
    setRows((prev) => prev.map((r) => ({ ...r, workDate: day.toISOString().split("T")[0] })));
  };

  const addRow = () => setRows((prev) => [...prev, emptyRow(`r_${Date.now()}`)]);
  const removeRow = (id) => setRows((prev) => prev.filter((r) => r.__localId !== id));
  const updateRow = (id, field, val) => setRows((prev) => prev.map((r) => (r.__localId === id ? { ...r, [field]: val } : r)));

  const validate = () => {
    if (rows.length === 0) return "Add at least one task.";
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      if (!r.projectId || !r.issueTitle) return `Row ${i + 1}: Project and Task are required.`;
      if (isNaN(Number(r.hoursSpent))) return `Row ${i + 1}: Hours spent invalid.`;
    }
    return null;
  };

  const buildPayload = (r) => ({
    employeeId: Number(loginUser?.EmployeeId || 0),
    projectID: r.projectId,
    issueTitle: r.issueTitle,
    workingHours: r.hoursSpent,
    hoursBillable: r.hoursBillable,
    dutyTypeId: r.dutyTypeId,
    status: r.status,
    description: r.description,
    workDate: r.workDate,
    employeeTimeSheetId: r.employeeTimeSheetId || null,
    employeeTimeSheetStatusId: r.employeeTimeSheetStatusId || null,
  });

  const handleSave = async () => {
    const err = validate();
    if (err) {
      setMessage({ type: "error", text: err });
      return;
    }
    setLoading(true);
    try {
      const results = [];
      for (const r of rows) {
        const payload = buildPayload(r);
        const res = mode === "edit" && r.employeeTimeSheetId ? await api.task().updateTask(payload) : await api.task().addTask(payload);
        results.push(res.data || res);
      }
      setMessage({ type: "success", text: "Saved successfully." });
      onSaved(results);
    } catch (e) {
      console.error(e);
      setMessage({ type: "error", text: e?.response?.data?.message || "Failed to save." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    try { console.debug('[AED] useEffect mount - adding key listener, isOpenAddEditForm=', isOpenAddEditForm); } catch(e){}
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      try { console.debug('[AED] useEffect cleanup - removing key listener'); } catch(e){}
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  const modal = (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.45)", zIndex: 99998, display: "flex", alignItems: "stretch", justifyContent: "center" }}>
      <div style={{ background: "#fff", width: "100%", height: "100%", maxWidth: "1200px", borderRadius: 8, overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.25)", display: "flex", flexDirection: "column" }}>
        <header style={{ background: "linear-gradient(90deg,#0fb7a1,#0aa59a)", color: "#fff", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>{mode === "edit" ? "Edit Timesheet" : "Add Timesheet"}</h2>
            <div style={{ fontSize: 12, opacity: 0.9, marginTop: 4 }}>Auto-saved just now</div>
          </div>
          <button onClick={handlecloseform} aria-label="close" style={{ background: "transparent", border: "none", color: "#fff", fontSize: 20, cursor: "pointer" }}>✕</button>
        </header>

        <div style={{ flex: 1, overflow: "auto", padding: 24 }}>
          <div style={{ textAlign: "center", marginBottom: 18 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 12 }}>
              <button onClick={() => navigateWeek("prev")} style={navArrowStyle}>{"\u00ab"}</button>
              <button onClick={() => navigateWeek("prev")} style={navArrowStyle}>{"\u2039"}</button>
              <div style={{ minWidth: 240, textAlign: "center", fontSize: 16 }}>{formatDateRange()}</div>
              <button onClick={() => navigateWeek("next")} style={navArrowStyle}>{"\u203a"}</button>
              <button onClick={() => navigateWeek("next")} style={navArrowStyle}>{"\u00bb"}</button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 12, maxWidth: "1000px", margin: "0 auto" }}>
              {weekDays.map((d, i) => {
                const isSel = selectedDate && d.toDateString() === selectedDate.toDateString();
                const isWeekend = [0, 6].includes(d.getDay());
                return (
                  <button key={i} onClick={() => handleSelectDay(d)} style={dayCardStyle(isSel, isWeekend)}>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>{d.toLocaleDateString(undefined, { weekday: "short" })}</div>
                    <div style={{ fontSize: 20, marginTop: 6 }}>{d.getDate()}</div>
                  </button>
                );
              })}
            </div>

            <div style={{ marginTop: 12, display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}><div style={{ width: 12, height: 12, background: "#0fb7a1", borderRadius: 4 }}></div><div style={{ fontSize: 12 }}>selected date</div></div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}><div style={{ width: 12, height: 12, background: "#fce7f3", borderRadius: 4 }}></div><div style={{ fontSize: 12 }}>Weekend/Holiday</div></div>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {rows.map((r) => (
              <div key={r.__localId} style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 12, alignItems: "center" }}>
                  <div>
                    <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Project Name</label>
                    <select style={inputStyle} value={r.projectId} onChange={(e) => updateRow(r.__localId, "projectId", e.target.value)}>
                      <option value="">Select project</option>
                      {projects.map((p) => <option key={p.projectID ?? p.id} value={p.projectID ?? p.id}>{p.projectName ?? p.name}</option>)}
                    </select>
                  </div>

                  <div>
                    <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Task Name</label>
                    <input style={inputStyle} value={r.issueTitle} onChange={(e) => updateRow(r.__localId, "issueTitle", e.target.value)} placeholder="Task name" />
                  </div>

                  <div>
                    <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Hours Spent</label>
                    <input style={inputStyle} value={r.hoursSpent} onChange={(e) => updateRow(r.__localId, "hoursSpent", e.target.value)} />
                  </div>

                  <div>
                    <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Hours Billable</label>
                    <input style={inputStyle} value={r.hoursBillable} onChange={(e) => updateRow(r.__localId, "hoursBillable", e.target.value)} />
                  </div>

                  <div>
                    <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Duty Type</label>
                    <select style={inputStyle} value={r.dutyTypeId} onChange={(e) => updateRow(r.__localId, "dutyTypeId", e.target.value)}>
                      <option value="">Select type</option>
                      {dutytypeList.map(d => <option key={d.dutyTypeId ?? d.id} value={d.dutyTypeId ?? d.id}>{d.type ?? d.name}</option>)}
                    </select>
                  </div>

                  <div>
                    <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Status</label>
                    <select style={inputStyle} value={r.status} onChange={(e) => updateRow(r.__localId, "status", e.target.value)}>
                      <option value="">Select status</option>
                      <option value="Working">Working</option>
                      <option value="Completed">Completed</option>
                      <option value="Pending">Pending</option>
                      <option value="OnHold">On Hold</option>
                    </select>
                  </div>
                </div>

                <div style={{ marginTop: 18 }}>
                  <label style={{ display: "block", fontSize: 14, marginBottom: 6 }}>Description</label>
                  <textarea style={{ width: "100%", minHeight: 90, padding: 12, borderRadius: 6, border: "1px solid #e5e7eb" }} value={r.description} onChange={(e) => updateRow(r.__localId, "description", e.target.value)} placeholder="Enter detailed task description"></textarea>
                </div>

                <div style={{ marginTop: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>Work Date: {r.workDate}</div>
                  <div>
                    <button onClick={() => removeRow(r.__localId)} disabled={rows.length === 1} style={{ padding: "6px 10px", borderRadius: 6, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer" }}>Remove</button>
                  </div>
                </div>
              </div>
            ))}

            <div style={{ display: "flex", justifyContent: "center", marginTop: 12, marginBottom: 40 }}>
              <button onClick={addRow} style={{ border: "2px dashed #d1d5db", padding: "14px 24px", borderRadius: 8, background: "transparent", cursor: "pointer", color: "#374151" }}>➕ Add Another Task</button>
            </div>
          </div>
        </div>

        <div style={{ borderTop: "1px solid #e5e7eb", padding: 16, display: "flex", justifyContent: "flex-end", gap: 12, background: "#fff" }}>
          <button onClick={handlecloseform} style={{ padding: "10px 16px", borderRadius: 6, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer" }}>Cancel</button>
          <button onClick={handleSave} disabled={loading} style={{ padding: "10px 18px", borderRadius: 6, background: "#0fb7a1", color: "#fff", border: "none", cursor: "pointer" }}>{loading ? "Saving..." : savingLabel}</button>
        </div>
      </div>
    </div>
  );

  // Do not render the portal if the parent hasn't opened the form
  if (!isOpenAddEditForm) {
    try { console.debug('[AED] isOpenAddEditForm is false - not rendering portal'); } catch(e){}
    return null;
  }

  return ReactDOM.createPortal(modal, document.body);
}
